import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=7ddc2ed0&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=7ddc2ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc2ed0",
  null
  
)

export default component.exports